import React from "react";
import { useSelector } from "react-redux";

import history from "../../router/history";
import { auth } from "../../firebase.config";

import Button from "@material-ui/core/Button";

const GoToLoginPage = () => {
  history.push("/Signin");
};

function LoginButton() {
  const user = useSelector((state) => state.auth);

  if (!user) {
    return (
      <Button color="inherit" onClick={GoToLoginPage}>
        Login
      </Button>
    );
  } else if (user) {
    return (
      <Button color="inherit" onClick={() => auth.signOut()}>
        Logout
      </Button>
    );
  }
}

export default LoginButton;
